import { Component } from '@angular/core';

@Component({
  selector: 'portal-erfolg-3-svg',
  standalone: true,
  templateUrl: './erfolg-3.component.svg',
  styleUrl: './erfolg-3.component.scss',
})
export class Erfolg3SvgComponent {}
